import {useEffect, useMemo, useState} from 'react';
import {Navigate} from 'react-router-dom';
import Login from "../views/login/Login";
import ForgotPassword from "../views/forgot-password/ForgotPassword";
import TokenVerification from "../views/token-verification/TokenVerification";
import {AppDispatch, useSelector} from "../redux/store";
import PageWrapper from "../layouts/full/dataShield/PageWrapper";
import Logout from "../views/logout/Logout";
import {logout} from "../redux/actions/authActions";
import Home from "../views/home/Home";
import Analysis from "../views/analysis/Analysis";
import Reports from '../views/reports/Reports';
import ReportPages from '../views/reports/[id]/reportpages';
import CacheService from '../services/CacheService';
import LogoSpinner from '../components/LogoSpinner/LogoSpinner';

/* ****Pages***** */
const Routes = () => {
	const accessToken = useSelector((state) => state.auth.accessToken)
	const [isCheckingAuth, setIsCheckingAuth] = useState(true);

	// Auth check tamamlandıktan sonra loading'i kapat
	useEffect(() => {
		const timer = setTimeout(() => {
			setIsCheckingAuth(false);
		}, 200);

		return () => clearTimeout(timer);
	}, []);

	// Auth kontrolü devam ediyorsa loading göster
	if (isCheckingAuth) {
		return [{
			path: '*',
			element: <LogoSpinner size={64} minHeight="100vh" />
		}];
	}

	// Token yoksa login sayfalarını göster
	if (!accessToken) {
		return [
			{
				path: '/',
				element: <Navigate to="/login" replace />,
			},
			{
				path: '/login',
				element: <Login/>,
			},
			{
				path: '/verification',
				element: <TokenVerification/>,
			},
			{
				path: '/forgot-password',
				element: <ForgotPassword/>,
			},
			{
				path: '*',
				element: <Navigate to="/login" replace />,
			}
		];
	}

	// Token varsa authenticated sayfaları göster
	return [
		{
			path: '/',
			element: <PageWrapper/>,
			children: [
				{
					path: '/',
					element: <Home/>
				},
				{
					path: '/home',
					element: <Home/>
				},
				{
					path: '/analysis',
					element: <Analysis/>,
				},
				{
					path: '/reports',
					element: <Reports />,
				},
				{
					path: '/reports/:id',
					element: <ReportPages />
				},
				{
					path: '/notifications',
					element: <div>Notifications Page</div>,
				},
				{
					path: '/logout',
					element: <Logout/>,
				},
			],
		},
		{
			path: '/login',
			element: <Navigate to="/" replace />,
		},
		{
			path: '*',
			element: <Navigate to="/" replace />,
		}
	];
}

export default Routes;
